import React from 'react';
import classNameBind from 'classnames/bind';
import Icon from '../Icon';
import styles from './PickerButton.module.css';
import Tooltip from '../Tooltip';

const bindClasses = classNameBind.bind(styles);

const PickerButton = ({ children, dataId, icon, tooltip, disabled, invalid }) => {
  const getIconColor = () => {
    if (disabled) { return 'gray'; }

    if (invalid) { return 'red'; }

    return 'default';
  };

  const button = (
    <div className={bindClasses('button', { disabled, invalid })}>
      <div className={bindClasses('icon')} data-ppuc-id={`${dataId}.icon`}>
        {icon.type === 'icon' ? (
          <Icon name={icon.content} color={getIconColor()} />
        ) : (
          icon.content
        )}
      </div>
      <div className={bindClasses('value')} data-ppuc-id={`${dataId}.value`}>{children}</div>
    </div>
  );

  return (
    tooltip ? (
      <Tooltip
        caption={tooltip.caption}
        title={tooltip.title}
        content={tooltip.content}
      >
        {button}
      </Tooltip>
    ) : button
  );
};

PickerButton.defaultProps = {
  disabled: false,
  invalid: false,
  tooltip: undefined,
  icon: undefined,
};

export { PickerButton };
